import React from 'react';
import { Link } from 'react-router-dom';
import './PageBanner.css';

interface BreadcrumbItem {
    label: string;
    path?: string;
}

interface PageBannerProps {
    title: string;
    subtitle?: string;
    backgroundImage?: string;
    badge?: string;
    breadcrumbs?: BreadcrumbItem[];
}

const PageBanner: React.FC<PageBannerProps> = ({
    title,
    subtitle,
    backgroundImage,
    badge,
    breadcrumbs
}) => {
    return (
        <section
            className="page-banner"
            style={{ backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined }}
        >
            <div className="page-banner-overlay"></div>
            <div className="container">
                {badge && <div className="page-banner-badge">{badge}</div>}
                <h1 className="page-banner-title">{title}</h1>
                {subtitle && <p className="page-banner-subtitle">{subtitle}</p>}
                {breadcrumbs && breadcrumbs.length > 0 && (
                    <nav className="page-banner-breadcrumb">
                        {breadcrumbs.map((item, index) => (
                            <React.Fragment key={index}>
                                {item.path ? (
                                    <Link to={item.path} className="breadcrumb-item">
                                        {item.label}
                                    </Link>
                                ) : (
                                    <span className={`breadcrumb-item ${index === breadcrumbs.length - 1 ? 'active' : ''}`}>
                                        {item.label}
                                    </span>
                                )}
                                {index < breadcrumbs.length - 1 && (
                                    <span className="breadcrumb-separator">›</span>
                                )}
                            </React.Fragment>
                        ))}
                    </nav>
                )}
            </div>
        </section>
    );
};

export default PageBanner;
